<template>
  <Select :value="fieldData.value" clearable @on-change = "selectChange">
    <Option
      :value="item.value"
      v-for="(item,index) in list"
      :key="index"
    >{{item.label}}</Option>
  </Select>
</template>

<script>
export default {
  props: {
    value: '',
    fieldData: {}
  },
  data() {
    return {
      constType: {
        insertId: '@id',
        selectType: 'select',
        insertType: 'insert',
        updateType: 'update',
        deleteType: 'delete',
        selectWhereOf: 'is_delete=0'
      },
      list: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getObjectSelectData(data) {
      console.log('关联', data)
      this.$emit('change', data)
    },
    //change事件
    selectChange(val){
        console.log('关联change', val)
        if(val){
            for(let i = 0;i<this.list.length;i++){
                if(this.list[i].value == val){
                    this.getObjectSelectData(this.list[i])
                }
            }
        }else{
            //处理清空的情况
            if(this.list.length){
                this.getObjectSelectData({
                    __isEmpty: true,//判断空的条件
                    ...this.list[0],//赋值，引用字段只做判断
                    value: '',
                    label: '',
                })
            }
        }
    },
    getList() {
      let fieldData = this.fieldData
      this.$http
        .get(
          '/scmd/Object/baseGetObject?moId=' +
            fieldData.associatedObject +
            '&objectState=1'
        )
        .then(response => {
          if (response.data.returnCode === 0) {
            if (response.data.beans.length > 0) {
              var parentObjectTname = response.data.beans[0].objectTname
              this.$http
                .post('/scmd/custom/operCustom', {
                  Head: {
                    method: this.constType.selectType,
                    version: '1.0'
                  },
                  Data: [
                    {
                      moId: fieldData.associatedObject,
                      OBJECT_NAME: parentObjectTname,
                      whereOf: '',
                      operFields: '*',
                      page: { pageNumber: '1', pageSize: '1000' },
                      orderBy: ''
                    }
                  ]
                })
                .then(res => {
                  var resultMainData = res.data.beans
                  for (let i = 0; i < resultMainData.length; i++) {
                    this.list.push({
                      value: resultMainData[i].mt_id,
                      label: resultMainData[i][fieldData.referenceCname],
                      show: true,
                      currentObjectBean: resultMainData[i]
                    })
                  }
                  //this.queryCustomDatas()
                })
            }
          }
        })
    }
  }
}
</script>

<style>
</style>